import React, { useState } from 'react';
import { FaTimes, FaWallet } from 'react-icons/fa';
import './TopupModal.css';

const TopupModal = ({ isOpen, onClose, userDetails, onConfirm }) => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleAmountChange = (e) => {
    const value = e.target.value;
    // Only allow numbers and decimal point
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setAmount(value);
      setError('');
    }
  };

  const validateAmount = () => {
    if (!amount || amount === '') {
      setError('Please enter an amount');
      return false;
    }

    const numAmount = parseFloat(amount);
    if (isNaN(numAmount) || numAmount <= 0) {
      setError('Please enter a valid amount greater than 0');
      return false;
    }

    if (numAmount > 100000) {
      setError('Maximum topup amount is $100,000');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateAmount()) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onConfirm(parseFloat(amount));
      // Reset form on success
      setAmount('');
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to process topup');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setAmount('');
      setError('');
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            <FaWallet /> Topup Account
          </h2>
          <button
            className="modal-close"
            onClick={handleClose}
            disabled={loading}
          >
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="user-info-box">
            <p><strong>User ID:</strong> #{userDetails.id}</p>
            <p><strong>Wallet:</strong> {userDetails.wallet}</p>
            <p><strong>Current Balance:</strong> ${Number(userDetails.available_income).toLocaleString()}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="amount">Topup Amount (USD)</label>
              <div className="input-wrapper">
                <span className="currency-symbol">$</span>
                <input
                  type="text"
                  id="amount"
                  className="amount-input"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={handleAmountChange}
                  disabled={loading}
                  autoFocus
                />
              </div>
              {amount && !error && (
                <p className="amount-preview">
                  New Balance: ${(Number(userDetails.available_income) + parseFloat(amount || 0)).toLocaleString()}
                </p>
              )}
              {error && <p className="error-message">{error}</p>}
            </div>

            <div className="quick-amounts">
              <p>Quick Select:</p>
              <div className="quick-buttons">
                {[100, 500, 1000, 5000].map((val) => (
                  <button
                    key={val}
                    type="button"
                    className="quick-amount-btn"
                    onClick={() => {
                      setAmount(val.toString());
                      setError('');
                    }}
                    disabled={loading}
                  >
                    ${val}
                  </button>
                ))}
              </div>
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn-cancel"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn-confirm"
                disabled={loading || !amount}
              >
                {loading ? 'Processing...' : 'Confirm Topup'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TopupModal;